module.exports = __webpack_public_path__ + "img/toolsItem04.69f83b68.png";